import { createTheme } from '@material-ui/core/styles';
import Colors from './colors';
// https://material-ui.com/customization/default-theme/?expend-path=$.palette.background
const breakpointObject = createTheme({
    breakpoints: {
        // using bootstrap defined breakpoints for consistancy
        values: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
        },
    },
});
const theme = createTheme({
    breakpoints: {
        // using bootstrap defined breakpoints for consistancy
        values: {
            ...breakpointObject.breakpoints.values,
        },
    },
    typography: {
        useNextVariants: true,
        fontFamily: '"Open Sans", sans-serif',
        h1: {
            fontSize: 68,
            lineHeight: '1em',
            fontWeight: 400,
            fontStyle: 'normal',
            fontFamily: 'chaneyregular, sans-serif',
            [breakpointObject.breakpoints.down('sm')]: {
                fontSize: 28,
            },
        },
        h3: {
            fontSize: 18,
            fontFamily: 'chaneyregular, sans-serif',
            color: Colors.black,
        },
        h4: {
            fontSize: 28,
            fontWeight: 400,
            fontStyle: 'normal',
            fontFamily: 'chaneyregular, sans-serif',
            [breakpointObject.breakpoints.down('sm')]: {
                fontSize: 22,
            },
        },
        body1: {
            fontSize: 16,
            fontWeight: 400,
            [breakpointObject.breakpoints.down('sm')]: {
                fontSize: 15,
                lineHeight: '1.2em',
            },
        },
        body2: {
            fontSize: 19,
            fontWeight: 800,
        },
        button: {
            textTransform: 'none',
            backgroundColor: Colors.white,
            '&:hover, &:focus': {
                backgroundColor: Colors.white,
            },
        },
    },
    palette: {
        primary: {
            main: Colors.red,
            // contrastText: '#fff',
        },
        secondary: {
            main: Colors.blue,
        },
        background: {
            default: Colors.pageBackground,
        },
    },
});

export default theme;
